/**
 * Highlights today's business hours row and shows Open/Closed status.
 */
(function () {
  const DAY_KEYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

  function parseTime12h(value) {
    const match = String(value).trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
    if (!match) return null;

    let hours = Number(match[1]);
    const minutes = Number(match[2]);
    const period = match[3].toUpperCase();

    if (period === 'PM' && hours !== 12) hours += 12;
    if (period === 'AM' && hours === 12) hours = 0;

    return hours * 60 + minutes;
  }

  function parseHoursText(text) {
    if (!text || /closed/i.test(text)) {
      return { closed: true };
    }

    const match = String(text).match(
      /(\d{1,2}:\d{2}\s*[AP]M)\s*[–—-]\s*(\d{1,2}:\d{2}\s*[AP]M)/i
    );

    if (!match) {
      return { closed: true };
    }

    const open = parseTime12h(match[1]);
    const close = parseTime12h(match[2]);

    if (open === null || close === null) {
      return { closed: true };
    }

    return { closed: false, open, close };
  }

  function getNowInTimezone(timezone) {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    });

    const parts = formatter.formatToParts(new Date());
    const weekday = parts.find((part) => part.type === 'weekday')?.value?.toLowerCase();
    const hour = Number(parts.find((part) => part.type === 'hour')?.value || 0);
    const minute = Number(parts.find((part) => part.type === 'minute')?.value || 0);

    return {
      dayIndex: DAY_KEYS.indexOf(weekday),
      minutes: hour * 60 + minute,
    };
  }

  function isOpenNow(schedule, minutes) {
    if (schedule.closed) return false;
    if (schedule.close > schedule.open) {
      return minutes >= schedule.open && minutes < schedule.close;
    }
    return minutes >= schedule.open || minutes < schedule.close;
  }

  function applyStatus(statusEl, open) {
    statusEl.classList.remove(
      'business-hours__status--open',
      'business-hours__status--closed',
      'ps-status-chip--open',
      'ps-status-chip--closed'
    );
    statusEl.removeAttribute('style');
    statusEl.hidden = false;

    if (open) {
      statusEl.textContent = 'Open';
      statusEl.classList.add('business-hours__status--open', 'ps-status-chip--open');
      statusEl.style.backgroundColor = '#056d21';
      statusEl.style.color = '#ffffff';
      return;
    }

    statusEl.textContent = 'Closed';
    statusEl.classList.add('business-hours__status--closed', 'ps-status-chip--closed');
  }

  function initContainer(container) {
    const timezone = container.dataset.timezone || 'America/New_York';
    const { dayIndex, minutes } = getNowInTimezone(timezone);

    container.querySelectorAll('[data-hours-text]').forEach((row) => {
      const rowDay = Number(row.dataset.day);
      const statusEl = row.querySelector('[data-hours-status]');
      const hoursText = row.dataset.hoursText || '';
      const schedule = parseHoursText(hoursText);

      row.classList.toggle('business-hours__row--today', rowDay === dayIndex);

      if (!statusEl || rowDay !== dayIndex) return;

      if (schedule.closed) {
        applyStatus(statusEl, false);
        return;
      }

      applyStatus(statusEl, isOpenNow(schedule, minutes));
    });
  }

  function init() {
    document.querySelectorAll('[data-business-hours]').forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
